import { NavigationBarAccessory } from '@components/navigationBar/NavigationBar'
import { RootStackParamList } from '@src/navigation/types'

interface UseIntercomMessageNavigationAccessoryParams {
  source: keyof RootStackParamList
}

export const useIntercomMessageNavigationAccessory = (
  _params: UseIntercomMessageNavigationAccessoryParams,
): NavigationBarAccessory[] => {
  return []
}
